import { render } from "./DetailsPage.vue?vue&type=template&id=308c4aed"
import script from "./DetailsPage.vue?vue&type=script&lang=js"
export * from "./DetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__